type PushToSftpMode =
  | "push"
  | "track"
  | "textNote"
  | "download"
  | "pushedDownload";

export const getSaveButtonText = (
  mode: PushToSftpMode,
  isPushing: boolean,
): string => {
  if (isPushing) {
    switch (mode) {
      case "track":
        return "Running...";
      case "textNote":
        return "Uploading...";
      case "download":
      case "pushedDownload":
        return "Downloading...";
      default:
        return "Pushing...";
    }
  }

  switch (mode) {
    case "track":
      return "Run Status";
    case "textNote":
      return "Upload Outcome";
    case "download":
    case "pushedDownload":
      return "Download File";
    default:
      return "Push to SFTP";
  }
};
